const $ = jQuery;

class SearchPage {
	constructor(){
		this.$form = $('#zn-page-search-form');
		this.$button = this.$form.find('[type="submit"]');
		this.$results = $('.zn-page-search-results');
		$(document).on('submit', '#zn-page-search-form', e => this.preventAndRefresh(e) );
		$(document).on('change', '#zn-page-search-form input[type="radio"]', e => this.refresh() );
	}

	preventAndRefresh(e){
		e.preventDefault();
		this.refresh();
	}

	refresh(){
		const queryString = this.$form.serialize();
		const path = this.$form.attr('action');

		const url = path + '?' + queryString;

		this.$button.prop('disabled', true);
		const $loading = $('<div class="zn-page-search-loading"></div>');
		$loading.appendTo(this.$results);
		
		history.replaceState( {}, '', url );

		$.get( url ).then( response => {

			const results = $(response).find('.zn-page-search-results');
			this.$results.html(results.html());

		}).always(()=>{
			$loading.remove();
			this.$button.prop('disabled', false);
		});
	}
}

$(()=>{
	if( $('body.search').length ){
		new SearchPage();
	}
});